import { ErrorSystemPage, ContentContainer } from '@snsw/react-component-library';
import React from 'react';
import { useHistory } from 'react-router-dom';

const getErrorMessage = code => {
    if (`${code}` === '404') {
        return 'The address specified does not exist.';
    } else if (code === 'startTransaction') {
        return 'An error occurred starting the transaction. Please try again later.';
    } else if (code === '401MFA') {
        return 'There was a technical issue on our end and you have been logged out.';
    } else if (code === '403' || code === '401') {
        return 'You are not logged in. Your session may have expired. Please try again.';
    } else if (code === '500') {
        return 'An error occurred during service call. Please try again later.';
    } else {
        return null;
    }
};

export const AppErrorPage = props => {
    const history = useHistory();

    const handleTryAgain = e => {
        console.debug('Try again clicked on error page.');
        history.push('/');
    };

    // console.debug('Error page with props:', props.match);

    return (
        <ContentContainer>
            <ErrorSystemPage
                heading='Sorry, we were unable to process your request'
                detail={ getErrorMessage(props?.match?.params?.code) }
                tryAgainOnClick={ handleTryAgain }
            />
        </ContentContainer>
    );
};
